// extracted by css-extract-rspack-plugin
export default {"item":"oGbmb4osyaEC5NHj","buttons":"PDqGf2v1mfQOrro6","error_message":"V6Ow2PBCyXcnRVuR"};